import React, { useState } from 'react';
import AdminAppBody from '../../../../components/admin/AdminAppBody';

const ReAssessmentTest = () => {
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [selectedOptions, setSelectedOptions] = useState({});

  const questions = [
    {
      title: "What is the output of the following code?",
      options: ["<class 'int'>", "<class 'float'>", "<class 'str'>", "<class 'bool'>"]
    },
    {
      title: "Which of the following is not a valid Python operator?",
      options: ["+", "==", "@", "||"]
    },
    {
      title: "What will be the output of: print(2 ** 3)?",
      options: ["6", "8", "9", "Error"]
    },
    {
      title: "Which of the following is used to define a function in Python?",
      options: ["function", "def", "fun", "define"]
    },
    {
      title: "Which data type is immutable?",
      options: ["List", "Dictionary", "Set", "Tuple"]
    },
    {
      title: "What is the correct file extension for Python files?",
      options: [".pt", ".py", ".python", ".p"]
    },
    {
      title: "Which keyword is used to create a class in Python?",
      options: ["object", "define", "class", "type"]
    },
    {
      title: "What will be the output of: print(3 == 3.0)?",
      options: ["True", "False", "Error", "None"]
    },
    {
      title: "Which of the following is a Python tuple?",
      options: ["[1, 2, 3]", "{1, 2, 3}", "(1, 2, 3)", "{1:2, 2:3}"]
    },
    {
      title: "What is the result of: len('Python')?",
      options: ["5", "6", "7", "Error"]
    }
  ];

  const totalQuestions = questions.length;
  const currentQuestion = questions[currentQuestionIndex];

  const handleOptionChange = (e) => {
    setSelectedOptions({
      ...selectedOptions,
      [currentQuestionIndex]: e.target.value
    });
  };

  const handleNext = () => {
    if (currentQuestionIndex < totalQuestions - 1) {
      setCurrentQuestionIndex(currentQuestionIndex + 1);
    }
  };

  const handlePrevious = () => {
    if (currentQuestionIndex > 0) {
      setCurrentQuestionIndex(currentQuestionIndex - 1);
    }
  };

  const handleSubmit = () => {
    // You can replace this with API submission logic
    alert("Test submitted! \nAnswers: " + JSON.stringify(selectedOptions, null, 2));
  };

  return (
    <AdminAppBody
      content={
        <div className="container py-4">
          {/* Header */}
          <h4 className="fw-bold">Intermediate Assessment on Python Basics</h4>
          <p className="text-muted">
            This assessment covers basic Python topics including data types, operators, control structures,
            functions, and basic data structures. There are 10 questions: 5 MCQs and 5 coding problems.
            Each question is worth 1 point.
          </p>

          {/* Question Card */}
          <div className="card p-4">
            <div className="mb-2 fw-bold text-muted">
              Question {currentQuestionIndex + 1} of {totalQuestions}
            </div>

            <h5 className="fw-bold">{currentQuestion.title}</h5>

            {/* Options */}
            <div className="mt-3">
              {currentQuestion.options.map((option, index) => (
                <div className="form-check border p-2 rounded my-2" key={index}>
                  <input
                    className="form-check-input ms-2"
                    type="radio"
                    name={`answer-${currentQuestionIndex}`}
                    id={`option-${currentQuestionIndex}-${index}`}
                    value={option}
                    checked={selectedOptions[currentQuestionIndex] === option}
                    onChange={handleOptionChange}
                    style={{ width: "20px", height: "20px" }} // Increase radio size
                  />
                  <label
                    className="form-check-label ms-2"
                    htmlFor={`option-${currentQuestionIndex}-${index}`}
                    style={{ fontSize: "1.1rem" }}
                  >
                    {option}
                  </label>
                </div>
              ))}
            </div>

            {/* Navigation Buttons */}
            <div className="d-flex justify-content-between mt-4">
              <button
                className="btn btn-primary text-white rounded"
                onClick={handlePrevious}
                disabled={currentQuestionIndex === 0}
              >
                <i className="bi bi-arrow-left"></i> Previous
              </button>

              {currentQuestionIndex === totalQuestions - 1 ? (
                <button
                  className="btn btn-success text-white rounded"
                  onClick={handleSubmit}
                >
                  Submit <i className="bi bi-check-circle ms-1"></i>
                </button>
              ) : (
                <button
                  className="btn btn-primary text-white rounded"
                  onClick={handleNext}
                >
                  Next <i className="bi bi-arrow-right ms-1"></i>
                </button>
              )}
            </div>
          </div>
        </div>
      }
    />
  );
};

export default ReAssessmentTest;
